import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Form, FieldTextInput, PrimaryButton } from '../../components';

import css from './EditListDetailsForm.module.css';

const EditListDetailsFormComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        handleSubmit,
        inProgress,
        ready,
        invalid,
        pristine,
        intl,
        form,
      } = fieldRenderProps;

      const nameLabel = intl.formatMessage({
        id: 'EditListDetailsForm.nameLabel',
      });
      const namePlaceholder = intl.formatMessage({
        id: 'EditListDetailsForm.namePlaceholder',
      });

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitReady = ready;
      const submitDisabled = invalid || submitInProgress || pristine;

      const onSubmit = async values => {
        await handleSubmit(values);
        // Reset form and clear validation state after successful submission
        form.restart();
      };

      return (
        <Form className={classes} onSubmit={onSubmit}>
          <div className={css.field}>
            <FieldTextInput
              id="name"
              name="name"
              type="text"
              label={nameLabel}
              placeholder={namePlaceholder}
              className={css.input}
            />
          </div>

          <PrimaryButton
            className={css.submitButton}
            readyClassName={css.submitButtonReady}
            type="submit"
            inProgress={submitInProgress}
            ready={submitReady}
            disabled={submitDisabled}
          >
            {intl.formatMessage({
              id: 'EditListDetailsForm.saveChanges',
            })}
          </PrimaryButton>
        </Form>
      );
    }}
  />
);

EditListDetailsFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  inProgress: false,
  ready: false,
};

const { bool, string } = PropTypes;

EditListDetailsFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  inProgress: bool,
  ready: bool,
  intl: intlShape.isRequired,
};

const EditListDetailsForm = compose(injectIntl)(EditListDetailsFormComponent);
EditListDetailsForm.displayName = 'EditListDetailsForm';

export default EditListDetailsForm;
